"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCertMoney = function SvgCertMoney(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C6A378"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.083,
    cy: 11.333,
    rx: 7.583,
    ry: 2.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.608 28.166c1.368.413 3.242.667 5.309.667 4.188 0 7.583-1.044 7.583-2.333 0-1.289-3.395-2.333-7.583-2.333-2.813 0-5.268.47-6.577 1.17"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M19.333 13.2c1.167 0 2.334 1.1 2.334 1.412 0 1.153-3.396 2.088-7.584 2.088S6.5 15.765 6.5 14.612c0-.344 1.167-1.412 2.333-1.412m30.334 15.167c1.166 0 2.333 1.1 2.333 1.412 0 1.153-3.395 2.088-7.583 2.088-2.082 0-3.967-.231-5.337-.605m-9.247-12.229c1.167 0 2.334 1.1 2.334 1.413 0 1.153-3.396 2.087-7.584 2.087S6.5 21.6 6.5 20.446c0-.345 1.167-1.413 2.333-1.413m4.885 12.248c-4.019-.053-7.218-.966-7.218-2.085 0-.345 1.167-1.413 2.333-1.413"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M19.333 16.117c1.167 0 2.334 1.1 2.334 1.412 0 1.153-3.396 2.088-7.584 2.088S6.5 18.682 6.5 17.529c0-.344 1.167-1.412 2.333-1.412m30.334 15.166c1.166 0 2.333 1.1 2.333 1.413 0 1.153-3.395 2.087-7.583 2.087-2.75 0-5.157-.402-6.487-1.005m-13.818-5.415c-3.969-.067-7.112-.975-7.112-2.084 0-.344 1.167-1.412 2.333-1.412"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14.53 25.446c-.148.003-.297.004-.447.004-4.188 0-7.583-.935-7.583-2.088 0-.344 1.167-1.412 2.333-1.412m6.214 12.233c-.316.011-.637.017-.964.017-4.188 0-7.583-.935-7.583-2.088 0-.344 1.167-1.412 2.333-1.412"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.083,
    cy: 29.417,
    r: 7.583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.167 25.359a682.99 682.99 0 0 0 3.5-.025C23.417 25.308 24 26.5 24 27.667M17 30a621.78 621.78 0 0 1 4.667 0c1.75.025 2.333-1.167 2.333-2.333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 34.083v-8.75m-1.75 7h7"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCertMoney);
var _default = exports["default"] = Memo;